import Vue from 'vue'
import './plugins/components'
import './plugins/bootstrap-vue'

new Vue({
  el: '#app',
  render: h => h('bc-cidr-main')
});
